/**
 * User type adapters
 * Single conversion point from UI AppUser (from useUniversalAuth) to UI AuthenticatedUser
 */

import type { AuthenticatedUser } from "@/lib/types/unified";

/**
 * AppUser type from useUniversalAuth hook (UI package)
 * This is different from database.AppUser
 */
type UIAppUser = {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  role?: string;
  roles?: {
    name: string;
    display_name?: string;
    permissions?: any;
  };
};

/**
 * Convert UI AppUser (from useUniversalAuth) to AuthenticatedUser (UI shape)
 * Ensures role is always a string (defaults to empty string if undefined)
 * Returns null if input is null
 */
export function toAuthenticatedUser(user: UIAppUser | null): AuthenticatedUser | null {
  if (!user) {
    return null;
  }

  return {
    ...user,
    role: user.role ?? "",
  } as AuthenticatedUser;
}

/**
 * Guard function to ensure user is authenticated (not null)
 * Useful for components that require an authenticated user
 */
export function requireAuthenticatedUser(
  user: AuthenticatedUser | null
): user is AuthenticatedUser {
  return user !== null;
}
